module.exports = __webpack_public_path__ + "img/gallery2.d5182e8d.webp";